import PaywallMyAccountPersonalDetails from "./paywallMyAccountPersonalDetails"
import PaywallMyAccountLastPurchases from "./paywallMyAccountpLastPurchases"
import PaywallMyAccountTabs from "./paywallMyAccountTabs";
import { useEffect, useState } from "react";
import { useRedirect } from "../../../../global/paywall/useRedirect";
import { SiteLinks } from "../../../../global/paywall/paywallInterfaces"
import { SettingLinks } from "../../premiumPaywallCheckout/components/premiumPaywallCheckout";
import { LinkTargetProperties } from "../../../../global/components/linkSettings/interfaces"
import { getNewlinkTargetProperties } from "../../ynet1280/ynetShops/data/ynetshopsData"
import { DetailsUpdateMode, DetailUpdateError, useDetailsUpdate } from "../../../../global/paywall/useDetailsUpdate";
import PaywallRevalidate from "../../paywallRevalidate/desktop/paywallRevalidate";
import { AuthLogOutLocal, getPaywallSettingsFromLocalStorage } from "../../../../global/paywall/authOperations";

declare const window: Window & {
    PAYWALL_SITE_LINKS: SiteLinks;
}

const targetLink: LinkTargetProperties = { ...getNewlinkTargetProperties(), linkOpenType: "new" }
const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';
const authPageUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.auth : '';
const privacyUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.privacy : '';
const termsUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS && window.PAYWALL_SITE_LINKS.terms
    ? window.PAYWALL_SITE_LINKS.terms
    : 'https://www.ynet.co.il/article/bkswwa3sn';

const settingLinks: SettingLinks = {
    authPage: { url: authPageUrl, target: targetLink },
    contact: { url: contactUrl, target: targetLink },
    privacy: { url: privacyUrl, target: targetLink },
    terms: { url: termsUrl, target: targetLink },
};

const PaywallMyAccountComponenta = () => {
    const {
        customerDetails,
        setStateCustomerDetails,
        revalidationType,
        setRevalidationType,
        error,
        revalidateUser,
        saved,
        revalidationStep,
        saveCustomerDetails,
        sendRevalidation,
        validateOtp
    } = useDetailsUpdate(DetailsUpdateMode.MY_ACCOUNT);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    useRedirect({ fallbackUrl: settingLinks.authPage.url, enabled: shouldRedirect });


    useEffect(() => {
        if (error === DetailUpdateError.NOT_LOGGED_IN) {
            setShouldRedirect(true);
            AuthLogOutLocal();
        }
    }, [error]);

    useEffect(() => {
        const userAgent = navigator.userAgent;
        const isIpadDevice = /iPad/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        if (isIpadDevice) {
            document.body.classList.add('ipad-device');
        }
    }, []);


    if (revalidateUser) {
        return <PaywallRevalidate
            userData={revalidateUser}
            step={revalidationStep}
            error={error}
            revalidationType={revalidationType}
            setRevalidationType={setRevalidationType}
            sendRevalidation={sendRevalidation}
            validateOtp={validateOtp}
        />;
    }

    const tabs = [
        {
            label: "המשתמש שלי",
            content: <PaywallMyAccountPersonalDetails
                setStateCustomerDetails={setStateCustomerDetails}
                customerDetails={customerDetails}
                saveCustomerDetails={saveCustomerDetails}
                error={error}
                saved={saved}
            />,
        },
        {
            label: "רכישות אחרונות",
            content: <PaywallMyAccountLastPurchases userData={customerDetails} contactUsPage={settingLinks.contact} />,
        },
    ];

    return (
        <div className="PaywallMyAccountComponenta">
            {customerDetails && <PaywallMyAccountTabs tabs={tabs} privacyPage={settingLinks.privacy} contactUsPage={settingLinks.contact} termsPage={settingLinks.terms} />}
        </div>
    );

};

export default PaywallMyAccountComponenta;

PaywallMyAccountComponenta.siteScriptName = "PaywallMyAccountComponenta"
